export enum Role {
  student = "STUDENT",
  teacher = "TEACHER",
  super = "SUPER",
  admin = "ADMIN",
}

export enum SubRoles {
  OBSERVER_STUDENT = "OBSERVER_STUDENT",
  OBSERVER_CLASS = "OBSERVER_CLASS",
  ADMIN_READ_ONLY = "ADMIN_READ_ONLY",
}

export enum ActivityType {
  study = "study",
  solo = "solo",
  tutor = "tutor",
  orchard_node = "orchard_node",
  orchard_node_h5p = "orchard_node_h5p",
  lti1p3_problem = "lti1p3_problem",
  digit_problem = "digit_problem",
}

export enum QuestionType {
  guided = "guided",
  mastery = "mastery",
  practice = "practice",
  sideNav = "sideNav",
}

export enum ContentType {
  solver = "solver",
  endOfTarget = "endOfTarget",
  endOfModule = "endOfModule",
}

export enum SkillType {
  TARGET_SKILL = "TARGET_SKILL",
  PROBLEM_SKILL = "PROBLEM_SKILL",
}

export enum HelpAndResourcesOptions {
  GUIDED_TOUR = "guidedTour",
  ACCESSIBILITY = "accessibility",
  CONTACT_TECH_SUPPORT = "contactTechSupport",
  TOS = "tos",
  ALL = "all",
}

export enum ExplorePageType {
  MODULE_PAGE = "MODULE_PAGE",
  SAVED_PAGE = "SAVED_PAGE",
  FILTER_PAGE = "FILTER_PAGE",
  SEARCH_PAGE = "SEARCH_PAGE",
}

export const ExplorePageNoResultMessage: { [key: string]: string } = {
  MODULE_PAGE: "No module videos found.",
  SAVED_PAGE:
    "You haven’t saved any videos. Use the Save Video bookmark button in a video to save it here.",
  FILTER_PAGE: "No results.",
  SEARCH_PAGE: "No results.",
};
export const INSIGHTS_SUMMARY_REPORT_TYPE: { [key: string]: string } = {
  STUDENT: "Student report",
  CLASS: "Class report",
};

export const DISABLED_USER_REASON: { [key: string]: string } = {
  NO_LOGIN: "No login with temporary password",
  NO_ACTIVITY: "No activity on the platform",
  CLASS_ENDED: "Student's class ended",
  NO_ACTIVE_CLASS: "Teacher has no active class",
  NO_SUBSCRIPTION: "School's subscription has ended",
  OTHER: "Other",
};

export enum NotificationType {
  Incorrect_Mastery = "Incorrect_Mastery",
  New_Course_Enrolled = "New_Course_Enrolled",
}

export enum TARGET_COMPLETION_STATUS {
  NEEDS_PRACTICE = "needspractice",
  IN_PROGRESS = "inprogress",
  NOT_STARTED = "notstarted",
  MASTERED = "mastered",
}

export enum _WindowMode {
  IFRAME = "iframe",
  TAB = "tab",
}

export enum _AuthType {
  SSO = "sso",
  COGNITO = "cognito",
  LOCAL = "local",
  LTI = "lti",
  WS = "ws",
}
